var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import PropTypes from 'prop-types';
import React from 'react';
import ReactLoadingSkeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
const Skeleton = (_a) => {
    var { circle, borderRadius, primaryColor, secondaryColor, style } = _a, props = __rest(_a, ["circle", "borderRadius", "primaryColor", "secondaryColor", "style"]);
    return (React.createElement(ReactLoadingSkeleton, Object.assign({}, props, { circle: circle, style: Object.assign(Object.assign({}, style), { backgroundColor: primaryColor, backgroundImage: `linear-gradient(90deg, ${primaryColor}, ${secondaryColor}, ${primaryColor})`, borderRadius: circle ? undefined : borderRadius }) })));
};
Skeleton.propTypes = {
    borderRadius: PropTypes.number,
    circle: PropTypes.bool,
    duration: PropTypes.number,
    fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    primaryColor: PropTypes.string,
    secondaryColor: PropTypes.string,
    style: PropTypes.object,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
Skeleton.defaultProps = {
    circle: false,
    borderRadius: 12,
    duration: 2,
    primaryColor: '#EBECEF',
    secondaryColor: '#f3f3f3',
};
export default Skeleton;
//# sourceMappingURL=index.js.map